var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#fff;}")),React.createElement("title",{"key":1},"Asset 1"),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":2},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},React.createElement("path",{"className":"cls-1","d":"M8.05,3.07H5.48V.5A.5.5,0,0,0,5,0H3.57a.5.5,0,0,0-.5.5V3.07H.5a.5.5,0,0,0-.5.5V5a.5.5,0,0,0,.5.5H3.07V8.05a.5.5,0,0,0,.5.5H5a.5.5,0,0,0,.5-.5V5.48H8.05a.5.5,0,0,0,.5-.5V3.57A.5.5,0,0,0,8.05,3.07Z"})))]);
}

Plus.defaultProps = {"viewBox":"0 0 8.55 8.55"};

module.exports = Plus;

Plus.default = Plus;
